// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import jQuery from "jquery";
import ModulePreloader from "./modules/modulePreloader";
import ModuleNavigation from "./modules/moduleNavigation";
import Homepage from "./pages/homepage";
import Platform from "./pages/platform";
import Resources from "./pages/resources";
import Contact from "./pages/contact";
import Pricing from "./pages/pricing";
import ResourcesDetail from "src/scripts/pages/resources_detail";
import Demo from "src/scripts/pages/demo";
import Landingpage from "src/scripts/pages/landingpage";

jQuery(document).ready(function () {
  let pageName = jQuery('body').data('page');

  const modulePreloader = new ModulePreloader();
  modulePreloader.init();

  setTimeout(function () {

    const navigation = new ModuleNavigation();
    navigation.init();

    if(pageName === 'home'){
      const homepage = new Homepage();
      homepage.init();
    }
    else if(pageName === 'platform'){
      const platform = new Platform();
      platform.init();
    }
    else if(pageName === 'pricing'){
      const pricing = new Pricing();
      pricing.init();
    }
    else if(pageName === 'resources'){
      const resources = new Resources();
      resources.init();
    }
    else if(pageName === 'resources_detail'){
      const resourcesdetail = new ResourcesDetail();
      resourcesdetail.init();
    }
    else if(pageName === 'contact'){
      const contact = new Contact();
      contact.init();
    }
    else if(pageName === 'demo'){
      const demo = new Demo();
      demo.init();
    }
    else if(pageName === 'landingpage'){
      const landingpage = new Landingpage();
      landingpage.init();
    }
  }, 500);
});
